// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul[data-v-6e3758ae] li:first-child>button{--tw-border-opacity:1;border-color:#481d72;border-color:rgba(72,29,114,var(--tw-border-opacity))}ul[data-v-6e3758ae] li:first-child>button>span{--tw-text-opacity:1;color:#481d72;color:rgba(72,29,114,var(--tw-text-opacity))}[data-v-6e3758ae] .progress-stepper__step:after{height:3px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
